import MDinput from '@/components/MDinput';
import { validatorRequire, validatorRequireNumber } from '@/utils/validators';
import DateTimePicker from '@/components/DSE/DateTimePicker';
import Select from '@/components/DSE/Select';

export function getFormDefinition(vue) {
  return {
    name: {
      type: MDinput,
      props: {
        maxlength: 64
      },
      rules: [{ validator: validatorRequire }]
    },
    printProvider: {
      type: Select,
      props: {
        caption: 'printer.printProvider',
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('printProvider')
      },
      rules: [{ validator: validatorRequireNumber }]
    },
    typeOption: {
      type: Select,
      props: {
        caption: 'printer.typeOption',
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('printerType')
      },
      rules: [{ validator: validatorRequireNumber }]
    },
    statusOption: {
      type: Select,
      hideOnCreate: true,
      props: {
        caption: 'printer.statusOption',
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('printerStatus'),
        disabled: true
      }
    },
    statusText: {
      type: MDinput,
      hideOnCreate: true,
      props: {
        caption: 'printer.statusText',
        maxlength: 255,
        disabled: true
      }
    },
    statusReceivedAt: {
      type: DateTimePicker,
      hideOnCreate: true,
      props: {
        caption: 'printer.statusReceivedAt',
        disabled: true
      }
    }
  };
}
export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
